import React, { useEffect } from 'react'
import { SVGInjector } from '@tanem/svg-injector'
import { RenderAorB, RenderIf } from '../../utils/fns'

import ReactHtmlParser from 'react-html-parser'

export function StatusSection(props) {
  const { statusLevel, statusIconUrl, statusHeader, statusBody } = props

  useEffect(() => {
    const mySVGsToInject = document.querySelectorAll('img.injectSVG')
    SVGInjector(mySVGsToInject)
  })

  return RenderIf(
    statusBody,
    <div className={'notice' + (statusLevel ? ' -' + statusLevel : '')}>
      {RenderAorB(
        statusIconUrl,
        <span className="material-icons">{statusIconUrl}</span>,
        <span className="material-icons">info</span>,
      )}

      <div className="notice__text">
        {RenderIf(statusHeader, <div className="notice__header">{statusHeader}</div>)}
        <div className="notice__body">{ReactHtmlParser(statusBody)}</div>
      </div>
    </div>,
  )
}
